// extracted by mini-css-extract-plugin
export var background = "HomePage-module--background--1kQwD";
export var title = "HomePage-module--title--4L8fp";
export var subtitle = "HomePage-module--subtitle--3F3Iy";
export var content = "HomePage-module--content--3LpNQ";
export var greeting = "HomePage-module--greeting--rM_hE";
export var avatar = "HomePage-module--avatar--3u88k";